import React, { useState } from 'react';
import { Alert, FormControl, Modal } from 'react-bootstrap';
import { HHIEButton } from '../../../utility/HHIEButton';

export const DeactivateByWhen = (props) => {
    const [show, setShow] = useState(false);
    const [date, setDate] = useState(null);
    const [showError, setError] = useState(false);
    const [showSuccess, setSuccess] = useState(false);
    const [newCopy, setNewCopy] = useState(null);

    const handleDeactivateByWhen = async () => {
        const sfid = props.member.id;
        if (sfid === null || sfid === undefined || sfid === "" || date === null || date === undefined) {
            return;
        }
        const formData = new FormData();
        formData.append("sfid", sfid);
        formData.append("date", date);
        const requestOptions = {
            method: 'POST',
            body: formData
        }
        const memberHasSuccessfullyBeenRequestedToBeDeactivated 
            = await fetch('api/member/deactivate-member-by-date', requestOptions)
            .then(async (response) => {
                try {
                    return await response.json().then(json => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors)
                        return json.message
                    });
                }
                catch (error) {
                    console.log("response to json conversion error:", error);
                    return false;
                }
            })
            .catch((error) => {
                console.log("error getting response:",error);
                return false;
            });
        let membersCopy = [...props.members];
        if (memberHasSuccessfullyBeenRequestedToBeDeactivated) {
            for (let member of membersCopy) {
                if (member.id === sfid) {
                    member.deactivationDate = date;
                }
            }
            setNewCopy(membersCopy);
        }
        
        
        setError(!memberHasSuccessfullyBeenRequestedToBeDeactivated);
        setSuccess(memberHasSuccessfullyBeenRequestedToBeDeactivated);

    }
    const handleClose = () => {
        setError(false);
        setSuccess(false);
        setShow(false);
        if (newCopy !== null) {
            props.setMembers(newCopy);
        }
        
    }
    const fullname = () => {
        var middleName = (props.member.middleName) ? props.member.middleName + " " : "";
        return props.member.firstName + " " + middleName + props.member.lastName;
    }
    const todaysDate = () => {
        let currentDate = new Date();
        let cDay = currentDate.getDate();
        let cMonth = currentDate.getMonth() + 1;
        let cYear = currentDate.getFullYear();
        return cMonth + "-" + cDay + "-" + cYear;
    }
    const thirtyDays = () => {
        let currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + 30);
        let cDay = currentDate.getDate();
        let cMonth = currentDate.getMonth() + 1;
        let cYear = currentDate.getFullYear();
        return cMonth + "-" + cDay + "-" + cYear;
    }
    return (
        <>
        <HHIEButton 
            variant="warning"
            size="sm"
            disabled={props.member.deactivationRequested || props.member.processing}
            onClick={() => {
                setShow(true);
            }}
            title="Deactivate On:"
        />
        <Modal
            show={show}
            size="lg"
            centered
            backdrop="static"
            keyboard={false}
            onHide={() => { setShow(false); }}
        >
            {(!showSuccess && !showError) && <Modal.Header>
                <Modal.Title>Schedule a Deactivation Date for '{fullname()}'</Modal.Title>
            </Modal.Header>}
            <Modal.Body>
                {(!showSuccess && !showError) && <>Choose a date between today ({todaysDate()}) and 30 days ({thirtyDays()})
                <FormControl
                    type="date"
                    placeholder="Requested Date of Deactivation"
                    onChange={(e) => { 
                        const dateRequested = e.target.value;
                        setDate(dateRequested);
                    }}
                /></>}
                {showSuccess && <Alert variant="success">Successfully requested {fullname()}'s deactivation on {date}</Alert>}
                {showError && <Alert variant="danger">Something went wrong requesting {fullname()}'s deactivation.<hr/> <strong>TIP:</strong> Make sure you choose a date after {todaysDate()} and before 30 days ({thirtyDays()}) </Alert>}
            </Modal.Body>
            <Modal.Footer>
                {(date && !showSuccess && !showError) 
                && <HHIEButton 
                    className="submit-deactivation-request-by-when" 
                    variant="outline-danger" 
                    size="sm"
                    onClick={() => {handleDeactivateByWhen();}}
                    title="Submit Deactivation Request to the HHIE"
                    />}
                <HHIEButton 
                    className="close-button" 
                    variant="primary"
                    size="sm"
                    onClick={() => { handleClose(); }}
                    title="Close"
                />
            </Modal.Footer>
        </Modal>
    </>
    );
}
